import ContentPage from "./ContentPage";
import Highlighter from "./Highlighter";
import ColoursAndTypography from "./static/big-images/ColoursAndTypography.png";
import ButtonsAndControls from "./static/big-images/ButtonsAndControls.png";
import InputFields from "./static/big-images/InputFields.png";
import AnimatedDiv from "./AnimatedDiv";

function DesignSystem() {
  return (
    <ContentPage>
      <AnimatedDiv>
        <h2>Solibri Design System</h2>

        <h3>Role</h3>
        <p>
          Product Design Lead | Product Designer| UX Researcher | UX Writer{" "}
        </p>

        <h3>Why Design System?</h3>
        <p>
          Through the years Solibri existed without any streamlined design
          guidelines. In 2021, the company decided to introduce a new,
          revolutionary cloud-based Solibri Inside.
        </p>
        <p>
          The design system was needed to help streamline the process of
          creating accessible products. It provides a baseline for accessibility
          and takes away decision-making from designers so they can focus on the
          design itself. It was the time to finally address the fact that we
          couldn't move forward without a Design System.
        </p>
      </AnimatedDiv>
      <AnimatedDiv>
        <h3>Problem</h3>
        <p>
          Solibri brand existed on the web as separate identity based on the
          brand visual guidelines defined by an external creative agency. The
          problems with “Brand visual Guidelines” were:
        </p>
        <p>- Mix of brand guidelines and UI components </p>
        <p>
          - The UI components give some visual guidance but contained a single
          state and only one example
        </p>
        <p>
          - Accessibility was not taken into account -No usage definition
          neither for brand guidelines or UI components
        </p>
      </AnimatedDiv>
      <AnimatedDiv>
        <h3>Focus</h3>
        <Highlighter text="1. Accessibility." />
        <p>
          Designing an accessible design system is crucial for creating
          inclusive and user-friendly products. All the components were designed
          with accessibility in mind so that the implementation could fulfil
          WCAG standards for AA level.
        </p>

        <Highlighter text="2. Scalability." />
        <p>
          With the product portfolio growing we had to ensure maximum
          flexibility of components while delivering consistent solutions based
          on design patterns together with usage definition.
        </p>

        <Highlighter text="3. Not reinventing the wheel." />
        <p>
          It is important to remember that many of the design problems we
          encounter have already been solved by others. I've used{" "}
          <a
            href="https://carbondesignsystem.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Carbon Design System
          </a>{" "}
          and{" "}
          <a
            href="https://m3.material.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            Material Design
          </a>{" "}
          as inspiration and guidance.
        </p>
      </AnimatedDiv>
      <AnimatedDiv>
        <img
          className="ColoursAndTypography"
          src={ColoursAndTypography}
          style={{ margin: "48px 0px", width: "100%" }}
        ></img>
      </AnimatedDiv>
      <AnimatedDiv>
        <img
          className="ButtonsAndControls"
          src={ButtonsAndControls}
          style={{ margin: "48px 0px", width: "100%" }}
        ></img>
      </AnimatedDiv>
      <AnimatedDiv>
        <img
          className="InputFields"
          src={InputFields}
          style={{ margin: "48px 0px", width: "100%" }}
        ></img>
      </AnimatedDiv>
    </ContentPage>
  );
}
export default DesignSystem;
